import React, { useState, useCallback } from "react";
import { ProgressSpinner } from "primereact/progressspinner";
import { AnnualBarCharts } from "./components/AnnualBarCharts";
import { TotalStatTiles } from "./components/TotalStatTiles";

const Dashboard: React.FC = () => {
  const [tilesLoaded, setTilesLoaded] = useState(false);
  const [chartsLoaded, setChartsLoaded] = useState(false);

  const handleTilesLoaded = useCallback(() => setTilesLoaded(true), []);
  const handleChartsLoaded = useCallback(() => setChartsLoaded(true), []);

  const isLoading = !tilesLoaded || !chartsLoaded;

  return (
    <div>
      {isLoading && (
        <div className="flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}>
          <ProgressSpinner style={{ width: 56, height: 56 }} />
        </div>
      )}
      <div style={{ display: isLoading ? "none" : undefined }}>
        <div className="text-3xl font-semibold text-900 mb-4">Dashboard</div>
        <div className="grid">
          <TotalStatTiles onLoaded={handleTilesLoaded} />
        </div>
        <div className="grid">
          <AnnualBarCharts onLoaded={handleChartsLoaded} />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
